import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import { StepHeader } from 'components/StepWizard';

const DummyStep = ({ step, title }) => (
  <Box bg="white" borderRadius="default" boxShadow="hard" mb={6}>
    <StepHeader title={title} {...step} />
  </Box>
);

DummyStep.propTypes = {
  step: PropTypes.object,
  title: PropTypes.string,
};

DummyStep.defaultProps = {
  step: {},
  title: '',
};

export default DummyStep;
